import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import LanguageIcon from "@mui/icons-material/LanguageRounded";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { DataCollectionRequestInfo } from "../../../../api/types/dataCollectionTypes";
import ScheduleIcon from "@entrilia/shared/icons/ScheduleIcon";
import DataRequestsListActionsContext from "./DataRequestsListActionsContext";

export const ActionsCell = ({ row }: { row: DataCollectionRequestInfo }) => {
  const { hasPermissionsToManage, onPublish, onDelete } = useDefinedContext(DataRequestsListActionsContext);

  const canPublish = hasPermissionsToManage && row.status === "Draft" && row.totalSubmissions > 0;
  const canDelete = hasPermissionsToManage && row.status === "Draft";
  const canEditSchedule = hasPermissionsToManage && row.status === "Scheduled";

  const menuItems = [];

  if (canPublish) {
    menuItems.push({
      icon: <LanguageIcon />,
      label: "Publish",
      onClick: () => onPublish(row),
    });
  }

  if (canDelete) {
    menuItems.push({
      icon: <DeleteIcon color="error" />,
      label: "Delete",
      onClick: () => onDelete(row),
    });
  }

  if (canEditSchedule) {
    menuItems.push({
      icon: <ScheduleIcon />,
      label: "Edit Schedule",
      onClick: () => onPublish(row),
    });
  }

  if (menuItems.length === 0) {
    return null;
  }

  return <ActionsMenuButton items={menuItems} />;
};
